module.exports = __webpack_public_path__ + "ad71d1d46a3a36745429d188b604903e.MP3";